import { SellerNotifications } from 'components/sellers/SellerNotifications/SellerNotifications'
import { useAppSelector } from 'shared/hooks/useReduxHooks'
import { appSelectors } from 'store/app'

export const ProfileNotifications: React.FC = () => {
  const sellerId = useAppSelector(appSelectors.selectSellerId)
  return <SellerNotifications type='profile' sellerId={sellerId ?? ''} />
}
